export default "__VITE_ASSET__DHVGN4lz__"